/*
  Log URL

  This plugin is meant for MIS users who wish
  to record the URL of the app per session.

  This is useful in cases where there are multiple
  URLs originating from different campaignes.

  The plugin requires 'a' node to have a text input
  with metadata: log-url:true

*/

import { getmetadata } from "$json/lib/getmetadata";
import * as R from "ramda";

((doc, $) => {
  $(doc).on("bb:finalHandleData", (e, data) => {
    if (data && data.groups && data.groups.length) {
      const md = getmetadata(data).controls;
      md.forEach((control, id) => {
        if (R.has("log-url")(control)) {
          const input = doc.getElementById(id[0]);
          input.style.setProperty("display", "none");
          if (input.nodeName === "INPUT") {
            input.value = doc.location.href;
          }
        }
      });
    }
  });
})(document, jQuery);
